import React, { Component } from 'react'
// import PhotoLoader from '../PhotoLoader'
import TagsEditor from '../TagsEditor'
// import Switch from 'react-ios-switch'
import PhotoLoader from '../PhotoLoader'
import './styles/style.css'

class CompetencyEditor extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props.object
        }
    }

    render() {

        return (
            <div className="CompetencyEditorWrapper">
                <div className="ObjectPageWrapper">
                    <div className="ObjectTitleWrapper">
                        <span className="fieldLabel">
                            {'Название'}
                        </span>
                        <input type="text" value={this.state.title} placeholder={'Введите название'} className={'ObjectTitleInput'} onChange={(e) => {
                            this.setState({
                                title: e.nativeEvent.target.value
                            })
                        }} />
                    </div>
                    <div className="PageColumnsWrapper">
                        <div className="PageColumn">
                        <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Фото'}
                                </span>
                                <PhotoLoader
                                    filesList={this.state.photo}
                                    onLoad={(filesList) => {
                                        this.setState({
                                            photo: filesList
                                        },()=>{
                                            if (this.props.save) {
                                                this.props.save()
                                            }
                                        })
                                    }} />
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Иконка'}
                                </span>
                                <PhotoLoader
                                    filesList={this.state.icon}
                                    onLoad={(filesList) => {
                                        this.setState({
                                            icon: filesList
                                        },()=>{
                                            if (this.props.save) {
                                                this.props.save()
                                            }
                                        })
                                    }} />
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Теги'}
                                </span>
                                <TagsEditor tags={this.state.tags} onChange={(tags) => {
                                    this.setState({
                                        tags: tags
                                    })
                                }} />
                            </div>
                        </div>
                        <div className="PageColumn">

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Количество метров'}
                                </span>
                                <input placeholder={'Введите количество метров'} type="text" value={this.state.metrics} className="FormInput" onChange={(e) => {
                                    this.setState({
                                        metrics: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Подпись для слайдера'}
                                </span>
                                <input placeholder={'Введите описание'} type="text" value={this.state.descriptor} className="FormInput" onChange={(e) => {
                                    this.setState({
                                        descriptor: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CompetencyEditor


// WEBPACK FOOTER //
// ./src/Components/CompetencyEditor/index.js